import { z } from 'zod';

export const watchViewSchema = z.object({
    createdAt: z.iso.datetime(),
    explicit: z.boolean(),
    id: z.string(),
    implicit: z.boolean(),
    itemId: z.string(),
    muted: z.boolean(),
});

export type WatchView = z.infer<typeof watchViewSchema>;

export const watchListSchema = watchViewSchema.array();

export type WatchList = z.infer<typeof watchListSchema>;
